<template>
  <div class="rounded-lg bg-grey-lighter p-4 pt-5 pb-2 mb-4">
    <form action="" @submit.prevent="onSubmit">
      <h3 class="text-2xl font-extrabold mb-3">Sign In</h3>

      <div class="flex flex-col md:flex-row my-2">
        <div class="w-full md:w-1/2 md:mr-3 mb-5 md:mb-0">
          <label for="loginEmail" class="label block mb-2">Email</label>
          <input
            type="email"
            name="loginEmail"
            class="input block w-full"
            placeholder="Email address..."
            v-model="email"
          />
          <error-message :errors="getErrors('email')"></error-message>
        </div>
        <div class="w-full md:w-1/2 md:ml-2.5">
          <label for="loginPassword" class="label block mb-2">Password</label>
          <input
            type="password"
            name="loginPassword"
            class="input block w-full"
            placeholder="Password..."
            v-model="password"
          />
          <error-message :errors="getErrors('password')"></error-message>
        </div>
      </div>

      <div class="flex flex-col md:flex-row mt-2">
        <div class="w-full md:w-1/2 md:mr-3">
          <button type="submit" class="button min-w-0 w-full" :disabled="loggingIn">
            {{ loggingIn ? 'Logging in...' : 'Log in' }}
          </button>
        </div>
        <div class="w-full md:w-1/2 md:ml-2.5">
          <a
            :href="passwordResetUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="underline text-blue-brand"
          >
            Forgotten Password?</a
          >
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Route from '../src/Route';
import HandlesErrors from './Mixins/HandlesErrors';
import ErrorMessage from './ErrorMessage.vue';
import get from 'lodash/get';

export default {
  components: {
    ErrorMessage,
  },

  mixins: [HandlesErrors],

  data() {
    return {
      email: '',
      password: '',
      passwordResetUrl: Route('password.reset'),
      loggingIn: false,
    };
  },

  methods: {
    onSubmit() {
      this.loggingIn = true;

      axios
        .post(Route('login'), {
          email: this.email,
          password: this.password,
        })
        .then((response) => {
          const user = get(response, 'data.user');

          if (!user) {
            throw 'Failed to get user when logging in.';
          }

          this.$store.commit('user/SET_USER_DETAILS', user);
        })
        .catch(this.handleXHRErrors)
        .then(() => {
          this.loggingIn = false;
        });
    },
  },
};
</script>
